import React from "react";
import Link from "@qlik/qlik/src/components/Link";
import { getCardBodyContent } from "@qlik/qlik/src/lib/util/helpers";
import { useI18n } from "@qlik/utils/i18nContext";

const CardWithBorder = ({ data }) => {
    const { component, browsingContext } = data ?? {};
    const { i18n } = useI18n();
    const href =
        component?.cta?.[0]?.internalLink !== null
            ? i18n.getLangPrefixedPath(`/${component?.cta?.[0]?.internalLink?.slug}`)
            : component?.cta?.[0]?.externalUrl;
    const title = component?.title;
    const text = component?.cta?.[0]?.text;
    const imageUrl = component?.media?.[0]?.desktopMedia?.[0]?.secure_url
        ?.replace("/f_auto", "")
        .replace("/q_auto", "");
    const paragraph = getCardBodyContent(component, "richtext-mb-0");

    const linkProps = {
        className:
            "group/link block p-5 border border-stone/50 rounded xl:hover:shadow-lg transition-shadow duration-300",
        newWindow: browsingContext === "New Tab",
        to: href,
    };

    return (
        <div>
            <Link {...linkProps}>
                <div className="contain-paint">
                    {imageUrl && (
                        <picture>
                            <source media="(max-width:768px)" />
                            <img
                                loading="lazy"
                                src={imageUrl}
                                alt={title}
                                className="max-xl:max-w-87.5 w-full h-auto object-cover xl:group-hover/link:scale-105 transition-all duration-300 xl:h-[239px]"
                            />
                        </picture>
                    )}
                </div>
                <div className="flex flex-col pt-7.5 px-2.5 pb-2.5 xl:pt-10 xl:px-5 xl:pb-5">
                    {title && (
                        <p className="mb-3.75 text-md text-gray leading-tight tracking-normal font-semibold xl:text-xl">
                            {title}
                        </p>
                    )}
                    {paragraph && <div className="mb-7.25">{paragraph}</div>}
                    {text && (
                        <span className="green-link mt-auto xl:group-hover/link:text-dark-green xl:group-hover/link:after:arrow-green-dark xl:group-hover/link:after:translate-x-0.75">
                            {text}
                        </span>
                    )}
                </div>
            </Link>
        </div>
    );
};
export default CardWithBorder;
